import * as React from 'react';

function HomeIcon({ ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="293.976" height="298.733" viewBox="0 0 293.976 298.733" {...props}>
      <g id="Groupe_9003" data-name="Groupe 9003" transform="translate(0 0)">
        <g id="Groupe_8963" data-name="Groupe 8963" transform="translate(0 0)">
          <path
            id="Tracé_84030"
            data-name="Tracé 84030"
            d="M57.236,0C117.066.553,167.6,90.527,168.151,151.351s-29.237,80.142-89.067,79.59S.711,243.682.16,182.859-2.594-.55,57.236,0Z"
            transform="translate(139.697 13.901) rotate(30)"
            fill="#e3e3e3"
          />
          <path
            id="Tracé_84031"
            data-name="Tracé 84031"
            d="M71.852,0C130.1.1,200.444,80.849,200.547,139.041s-50.83,81.87-109.073,81.767S.1,216.983,0,158.791,13.609-.1,71.852,0Z"
            transform="translate(0 123.469) rotate(-38)"
            fill="#00a1a2"
          />
        </g>
        <g id="Groupe_8969" data-name="Groupe 8969" transform="translate(122 112.08)">
          <rect
            id="Rectangle_148187"
            data-name="Rectangle 148187"
            width="21.423"
            height="75.795"
            transform="translate(5.418 26.223)"
            fill="#f0f5fb"
          />
          <rect
            id="Rectangle_148186"
            data-name="Rectangle 148186"
            width="32.484"
            height="21.905"
            rx="1"
            transform="translate(7.637 1.335)"
            fill="#f0f5fb"
          />
          <path
            id="Rectangle_148185"
            data-name="Rectangle 148185"
            d="M9,0H32.484a0,0,0,0,1,0,0V96.451a1,1,0,0,1-1,1H3a3,3,0,0,1-3-3V9A9,9,0,0,1,9,0Z"
            fill="#111136"
          />
          <line
            id="Ligne_335"
            data-name="Ligne 335"
            x2="0.307"
            y2="25.467"
            transform="translate(3.363 20.277)"
            fill="none"
            stroke="#fff"
            strokeLinecap="round"
            strokeWidth="3"
          />
          <line
            id="Ligne_336"
            data-name="Ligne 336"
            x2="0.044"
            y2="3.637"
            transform="translate(3.302 9.69)"
            fill="none"
            stroke="#fff"
            strokeLinecap="round"
            strokeWidth="3"
          />
        </g>
        <line
          id="Ligne_331"
          data-name="Ligne 331"
          y1="4.988"
          x2="26.187"
          transform="translate(158.835 116.651) rotate(-7)"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeWidth="3"
          opacity="0.36"
        />
        <line
          id="Ligne_332"
          data-name="Ligne 332"
          x2="15.846"
          y2="1.809"
          transform="translate(161.198 126.58) rotate(-7)"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeWidth="3"
          opacity="0.36"
        />
        <line
          id="Ligne_333"
          data-name="Ligne 333"
          x2="15.698"
          y2="12.13"
          transform="translate(161.764 131.229) rotate(-7)"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeWidth="3"
          opacity="0.36"
        />
      </g>
    </svg>
  );
}

export default HomeIcon;
